import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from "react";
import ImagesCarousel from "../../details/images/imagesCarousel";
// Styles
import "../../../assets/saas/molecules/_slider-carrousel.scss";
import { urlTransform } from "../../../hooks/ImageHook";
import { useResponsiveScreen } from "../../../hooks/useResponsiveScreen";
import { parseRotatorImages, expandRotatorFramesFromSeed } from "../../../utils/rotatorUtils";
import ImageRotator from "../../commons/ImageRotator";
const resolveRotatorFrames = (image) => {
    const framesFromImages = parseRotatorImages(image === null || image === void 0 ? void 0 : image.images);
    const framesFromUrl = parseRotatorImages(image === null || image === void 0 ? void 0 : image.url);
    let frames = framesFromImages.length ? framesFromImages : framesFromUrl;
    if (frames.length <= 1 && (image === null || image === void 0 ? void 0 : image.url)) {
        frames = expandRotatorFramesFromSeed(typeof image.url === "string" ? image.url : String(image.url));
    }
    return frames;
};
const LogoCarImage = ({ mainImage = '', imagesMobi, id }) => {
    const { isMobile } = useResponsiveScreen();
    const [rotatorFailed, setRotatorFailed] = useState(false);
    return (_jsxs("div", { className: "slider-carrousel", children: [_jsx("div", { className: "hide-desktop", children: _jsx("img", { className: "slider-carrousel--imagen", src: urlTransform(mainImage, 800), alt: "", loading: "lazy" }) }), _jsx("div", { className: "hide-mobile carousel-desktop", children: imagesMobi && imagesMobi.length === 1 ? (() => {
                    const singleImage = imagesMobi[0];
                    const isRotator = String((singleImage === null || singleImage === void 0 ? void 0 : singleImage.type) || "").toLowerCase().includes("rotator");
                    const frames = isRotator ? resolveRotatorFrames(singleImage) : [];
                    if (isRotator && frames.length > 1 && !isMobile && !rotatorFailed) {
                        return (_jsx("div", { className: "desktop-image", children: _jsx(ImageRotator, { images: frames, height: "100%", fallbackSrc: urlTransform(mainImage, 800), onAllFramesFailed: () => setRotatorFailed(true) }) }));
                    }
                    return (_jsx("div", { className: "desktop-image", children: _jsx("img", { className: "slider-carrousel--imagen", src: urlTransform(singleImage.url, 800), alt: "", loading: "lazy" }) }));
                })() : (!isMobile &&
                    _jsx(ImagesCarousel, { images: imagesMobi, mainImage: mainImage, type: "availability", id: "video-modal_availability_" + id })) })] }));
};
export default LogoCarImage;
